import React, { useEffect, useState } from 'react';
import StickyBox from "react-sticky-box";

import './FixedBottom.css';

const FixedBottom = (props) => {

    // const [hideStatic, setHideStatic] = useState('');
    // const [hideFixed, setHideFixed] = useState('');

    // useEffect(() => {
    //     const handleScroll = (e) => {
    //         if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight-175)) {
    //             setHideStatic('');
    //             setHideFixed('');
    //         } 
    //     }
    //     window.addEventListener("scroll", handleScroll, { passive: true });

    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, []);


    return (
        <StickyBox bottom={true} offsetBottom={0} className="fixedBottom-container">
            <div className="subnavi-container">
                {props.children}
            </div>
        </StickyBox>
    );
}

export default FixedBottom;